var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
var getSize = function () { return ({
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
}); };
export var useWindowSize = function () {
    var _a = __read(useState(getSize()), 2), size = _a[0], setSize = _a[1];
    useEffect(function () {
        var handler = function () { return setSize(getSize()); };
        window.addEventListener("resize", handler);
        window.addEventListener("orientationchange", handler);
        return function () {
            window.removeEventListener("resize", handler);
            window.removeEventListener("orientationchange", handler);
        };
    }, []);
    return size;
};
